import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/services-list';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false
        };
        this.toggleModal = this.toggleModal.bind(this);
        return this;
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }
}
